// LGT Kategorie-Seite: Filter-Chips (sections/lgt-collection-books.liquid).
// Jeder Chip trägt eine Liste von Produkt-Handles ("*" = alle). Gefiltert wird nur
// sichtbar/unsichtbar, Karten im Raster erscheinen nur bei „Alle“.
(() => {
  const init = (root) => {
    const bar = root.querySelector('[data-lgt-chips]');
    if (!bar || bar.dataset.lgtReady) return;
    bar.dataset.lgtReady = '1';
    bar.hidden = false;

    const chips = [...bar.querySelectorAll('[data-lgt-chip]')];
    const items = [...root.querySelectorAll('[data-lgt-handle]')];
    const promos = [...root.querySelectorAll('[data-lgt-promo]')];
    const empty = root.querySelector('[data-lgt-empty]');

    const apply = (chip) => {
      const value = chip.dataset.lgtChip;
      const all = value === '*';
      const handles = new Set(value.split(',').filter(Boolean));
      let shown = 0;
      items.forEach((item) => {
        const visible = all || handles.has(item.dataset.lgtHandle);
        item.hidden = !visible;
        if (visible) shown += 1;
      });
      promos.forEach((promo) => { promo.hidden = !all; });
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      if (empty) empty.hidden = shown > 0;
    };

    chips.forEach((chip) => chip.addEventListener('click', () => {
      apply(chip);
      chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }));
    root.querySelector('[data-lgt-reset]')?.addEventListener('click', () => chips[0] && apply(chips[0]));
  };

  const run = () => document.querySelectorAll('[data-lgt-collection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
